module.exports = __webpack_public_path__ + "img/winnerstakeall.acb0ae3d.png";